const SupportIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <g clip-path="url(#clip0_6924_118)">
              <path d="M7.05355 7.05373L4.10728 4.10746M4.10728 15.8926L7.05357 12.9463M12.9461 12.9463L15.8924 15.8925M15.8924 4.10743L12.9461 7.05371M18.3332 10C18.3332 14.6024 14.6022 18.3333 9.99984 18.3333C5.39746 18.3333 1.6665 14.6024 1.6665 10C1.6665 5.39763 5.39746 1.66667 9.99984 1.66667C14.6022 1.66667 18.3332 5.39763 18.3332 10ZM14.1665 10C14.1665 12.3012 12.301 14.1667 9.99984 14.1667C7.69865 14.1667 5.83317 12.3012 5.83317 10C5.83317 7.69882 7.69865 5.83333 9.99984 5.83333C12.301 5.83333 14.1665 7.69882 14.1665 10Z" stroke="#344054" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
            </g>
            <defs>
              <clipPath id="clip0_6924_118">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
    )
}
export default SupportIcon;